module.exports = __webpack_public_path__ + "static/media/GalanoGrotesque-Bold.6d10397a.otf";